import { OpenClosedStates } from '@chiroup/core/enums/OpenClosedStates.enum';
import qs from 'query-string';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const useEditSlideOverState = (): [
  OpenClosedStates,
  Dispatch<SetStateAction<OpenClosedStates>>,
] => {
  const { search } = useLocation();
  const [editSlideOverState, setEditSlideOverState] = useState<OpenClosedStates>(
    OpenClosedStates.Closed
  );

  useEffect(() => {
    const queryParams = qs.parse(search);
    const editOpen = queryParams.open?.includes('edit');
    setEditSlideOverState(editOpen ? OpenClosedStates.Open : OpenClosedStates.Closed);
  }, [search]);

  return [editSlideOverState, setEditSlideOverState];
};
